import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Image,
  StackDivider,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  Tooltip,
  VStack,
} from '@chakra-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import TrophyImage from '../../assets/trophy.png';
import Header from '../../components/Header';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../components/Table/Table';
import { createClient } from '../../services/chainClient';
import { useAppDispatch, useTypedSelector } from '../../store';
import {
  BetState,
  fetchAllBetStates,
  hydrateBets,
} from '../../store/bets/betsSlice';
import { toBTC } from '../../utils/Utils';
import WithdrawAllWinningsModal from '../../components/WithdrawAllWinningsModal';

const PayoutTable = ({ bets }) => (
  <Box w="full">
    <Table>
      <TableHead>
        <TableRow>
          <TableHeader>Counterparty</TableHeader>
          <TableHeader>Counterparty Deposit</TableHeader>
          <TableHeader>Your Deposit</TableHeader>
          <TableHeader>Total Payout</TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {bets.map((bet) => (
          <TableRow bg="white">
            <TableCell>
              {bet.twitterInfo ? (
                <Flex width="fit-content" alignItems="center">
                  <Tooltip label={`@${bet.twitterInfo.screen_name}`} hasArrow>
                    <Box
                      mr={4}
                      borderRadius={100}
                      boxSize="30px"
                      bg="#EBEBEB"
                      flexShrink={0}
                      background={`url(${bet.twitterInfo.profile_image_url_https.replace(
                        'normal',
                        '200x200'
                      )})`}
                      backgroundSize="cover"
                    ></Box>
                  </Tooltip>
                  <Box
                    h="20px"
                    // w="125px"
                    maxW="200px"
                    fontSize="sm"
                    overflow="hidden"
                    whiteSpace="nowrap"
                    textOverflow="ellipsis"
                  >
                    {bet.twitterInfo.name}
                  </Box>
                </Flex>
              ) : (
                <Flex width="fit-content" alignItems="center">
                  <Box
                    mr={4}
                    borderRadius={100}
                    boxSize="30px"
                    bg="#EBEBEB"
                    flexShrink={0}
                    background={`grey`}
                    backgroundSize="cover"
                  ></Box>
                  <Box
                    h="20px"
                    // w="125px"
                    maxW="200px"
                    fontSize="sm"
                    overflow="hidden"
                    whiteSpace="nowrap"
                    textOverflow="ellipsis"
                  >
                    Anonymous User
                  </Box>
                </Flex>
              )}
            </TableCell>

            <TableCell>
              <Text fontSize="sm" color="#2EBB3C">
                {toBTC(bet.betDetails.betAmountCounter)} BTC
              </Text>
            </TableCell>

            <TableCell>
              <Text fontSize="sm">{toBTC(bet.betDetails.betAmount)} BTC</Text>
            </TableCell>

            <TableCell>
              <Text fontSize="sm">{toBTC(bet.betDetails.betSize)} BTC</Text>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Box>
);

const TotalPayout = () => {
  const history = useHistory();
  const mnemonic = useTypedSelector((state) => state.wallet.mnemonic);
  const bets = useTypedSelector((state) => state.bets);

  const [withdrawAllModalOpen, setWithdrawAllModalOpen] = useState(false);
  const [withdrawPayoutEnabled, setWithdrawPayoutEnabled] = useState(false);

  const dispatch = useAppDispatch();

  // retrieve won bets
  useEffect(() => {
    if (!mnemonic) return;

    createClient(mnemonic);
    dispatch(hydrateBets())
      .then(() => dispatch(fetchAllBetStates()))
      .then(() => setWithdrawPayoutEnabled(true));;
  }, [dispatch, mnemonic]);

  const wonBets = Object.values(bets).filter(
    (bet) => bet.stage === BetState.Withdrawable
  );

  return (
    <>
      <Box w="full">
        <Header
          h="180px"
          w="100%"
          backgroundColor="#42486b"
          alignItems="center"
          justifyContent="center"
        >
          <Heading color="white" size="lg" textAlign="center">
            US Presidential Election on November 3rd 2020
          </Heading>

          <Button
            bg="white"
            color="blue.600"
            borderColor="blue.600"
            borderWidth="1px"
            position="absolute"
            top="5"
            right="5"
            size="sm"
            colorScheme="white"
            onClick={() => history.push(`/dashboard`)}
          >
            Go to Dashboard
          </Button>
        </Header>

        <Box boxSize="full" p={4}>
          <VStack spacing={4} w="700px" mx="auto">
            <Flex justifyContent="center" h="80px">
              <Image src={TrophyImage} maxW="full" maxH="full" />
            </Flex>
            <Box boxSize="full">
              <HStack
                p={4}
                w="full"
                h="128px"
                bg="white"
                borderRadius="4px"
                justifyContent="space-around"
                divider={<StackDivider borderColor="gray.200" />}
              >
                <Stat textAlign="center" whiteSpace="nowrap">
                  <StatNumber>{wonBets.length}</StatNumber>
                  <StatLabel>Total Bets Won</StatLabel>
                </Stat>
                <Stat textAlign="center" whiteSpace="nowrap">
                  <StatNumber>
                    {toBTC(
                      wonBets.reduce(
                        (acc, bet) => bet.betDetails.betAmount + acc,
                        0
                      ),
                      4
                    )}{' '}
                    BTC
                  </StatNumber>
                  <StatLabel>Total Amount Wagered</StatLabel>
                </Stat>
                <Stat textAlign="center" whiteSpace="nowrap">
                  <StatNumber>
                    {toBTC(
                      wonBets.reduce(
                        (acc, bet) =>
                          bet.betDetails.betSize - bet.betDetails.betAmount + acc,
                        0
                      ),
                      4
                    )}{' '}
                    BTC
                  </StatNumber>
                  <StatLabel>Total Profit</StatLabel>
                </Stat>
                <Stat textAlign="center" whiteSpace="nowrap">
                  <StatNumber>
                    {toBTC(
                      wonBets.reduce((acc, bet) => bet.betDetails.betSize + acc, 0),
                      4
                    )}{' '}
                    BTC
                  </StatNumber>
                  <StatLabel>Total Payout</StatLabel>
                </Stat>
              </HStack>
              <Button 
                colorScheme="blue"
                w="full"
                size="sm"
                isLoading={!withdrawPayoutEnabled}
                onClick={() => setWithdrawAllModalOpen(true)}
              >
                Withdraw Total Payout
              </Button>
            </Box>

            <PayoutTable bets={wonBets} />
          </VStack>
        </Box>
      </Box>
      <WithdrawAllWinningsModal
        isOpen={withdrawAllModalOpen}
      />
    </>
  );
};

export default TotalPayout;
